import { RestService } from "./RestService";

export class ScheduledLocationService extends RestService {
    constructor() {
        super("/api/v1/scheduled_locations");
    }
}
